import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__section">
            <h3 className="footer__heading">Product</h3>
            <ul className="footer__links">
              <li>
                <a href="/#features" className="footer__link">How It Works</a>
              </li>
              <li>
                <a href="/#who-is-it-for" className="footer__link">Who It's For</a>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__heading">Company</h3>
            <ul className="footer__links">
              <li>
                <a href="/#about" className="footer__link">About</a>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__heading">Legal</h3>
            <ul className="footer__links">
              <li>
                <Link to="/privacy" className="footer__link">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="footer__link">Terms of Service</Link>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__heading">Contact</h3>
            <ul className="footer__links">
              <li>
                <a href="mailto:info@furudio.com" className="footer__link">info@furudio.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__brand">
            <img src="/Furudio-logo.svg" alt="Furudio" className="footer__logo" />
            <span className="footer__brand-name">Furudio</span>
          </div>
          <p className="footer__tagline">
            The name Furudio comes from the star Furud in the Canis Major constellation. 
            It symbolises how only by combining stars do they create a beautiful, unified picture.
          </p>
          <p className="footer__copyright">
            &copy; {currentYear} Furudio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
